/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from "react";
import "../../scss/custom.scss";
import { Dropdown, DataTableSkeleton, Pagination } from "carbon-components-react";
import AuditDetails from "./AuditDetails";
import DivisionsTab from "./common/DivisionsTab";
import AuditMultiSelectDataTable from "./common/AuditMultiSelectDataTable";
import { showNotification } from "../../helpers/notification/BaseNotification";
import { getError, apioperation, entitiesLabels } from "../../helpers/Constants";
import { AppContext } from "../../helpers/context/AppContext";
import { IsEnabled } from "../../helpers/authorization/Policies";
import PageBreadCrumb from "../../helpers/PageBreadCrumb";
import AuditRepository from "../../helpers/api/AuditRepository";
import MeRepository from "../../helpers/api/MeRepository";

export default class AuditList extends Component {
	constructor(props) {
		super(props);
		this.year = new Date().getFullYear();
		this.showAddAudit = this.showAddAudit.bind(this);
		this.showEditAudit = this.showEditAudit.bind(this);
		this.onDivisionTabSelected = this.onDivisionTabSelected.bind(this);
		this.onMonthFilter = this.onMonthFilter.bind(this);
		this.newAuditAdded = this.newAuditAdded.bind(this);
		this.auditUpdated = this.auditUpdated.bind(this);
		this.onYearChange = this.onYearChange.bind(this);
		this.onAuditTypeFilter = this.onAuditTypeFilter.bind(this);
		this.onAuditScopeFilter = this.onAuditScopeFilter.bind(this);
		this.onAuditReasonFilter = this.onAuditReasonFilter.bind(this);
		this.onAuditCountryFilter = this.onAuditCountryFilter.bind(this);
		this.onAuditProjectAuditeeFilter = this.onAuditProjectAuditeeFilter.bind(this);
		this.onAuditSubContractorFilter = this.onAuditSubContractorFilter.bind(this);
		this.onTargetFilter = this.onTargetFilter.bind(this);
		this.onStatusFilter = this.onStatusFilter.bind(this);
		this.onWorkSiteFilter = this.onWorkSiteFilter.bind(this);
		this.refreshData = this.refreshData.bind(this);
		this.repository = new AuditRepository();
		this.handleChangePaging = this.handleChangePaging.bind(this);
		this.onCompilerFilter = this.onCompilerFilter.bind(this);
		this.onPlanCompilerFilter = this.onPlanCompilerFilter.bind(this);
		this.onPurchaseOrderFilter = this.onPurchaseOrderFilter.bind(this);
		this.onDivisionManagerFilter = this.onDivisionManagerFilter.bind(this);
		this.onApproverFilter = this.onApproverFilter.bind(this);
		this.onCodeFilter = this.onCodeFilter.bind(this);
		this.onFindingCodeFilter = this.onFindingCodeFilter.bind(this);
		this.onProjectAuditCodeFilter = this.onProjectAuditCodeFilter.bind(this);
		this.onProjectFindingCodeFilter = this.onProjectFindingCodeFilter.bind(this);

		// this.getAuditCountByMonth = this.getAuditCountByMonth.bind(this);
		this.handleSearchClear = this.handleSearchClear.bind(this);
		this.onShowFilters = this.onShowFilters.bind(this);

		this.state = {
			idAudit: null,
			auditToModify: null,
			loading: false,
			items: [],
			itemsInMonths: [],
			allYearFilteredItems: [],
			originalItems: [],
			filteredMonth: null,
			filteredTab: null,
			filteredAuditScopes: [],
			filteredAuditReasons: [],
			filteredAuditCountries: [],
			filteredAuditProjectsAuditee: [],
			//filteredAuditSubContractors: [],
			filteredAuditSubContractors: null, //RITM0964998 - Download Audit Programs Fix
			filteredYear: this.getHashtagYear(),
			modalAuditVisible: false,
			filteredDivision: null,
			filteredAuditType: null,
			filteredTarget: null,
			filteredStatus: null,
			filteredPlanStatus: null,
			filteredAuditRemote: null,
			filteredWorkSites: [],
			filteredPlanCompiler: null,
			//filteredPurchaseOrder: [], //RITM0646764
			filteredPurchaseOrder: null, //RITM0964998 - Download Audit Programs Fix
			filteredApprover: null,
			filteredManager: null,
			filteredCompiler: null,
			filteredPlanCompiler: null,
			filteredCode: this.getHashtag(),
			filteredFindingCode: this.getHashtag(),
			filteredProjectAuditCode: this.getHashtag(),
			filteredProjectFindingCode: this.getHashtag(),
			currentPage: 1,
			totalAudits: 0,
			pageSize: 10,
			showFilters: false,
			//userDivision: [], //B1_Audit_Module_Optimization
			isBack: this.props.history.action === "POP" || this.props.location.search === "?isBack" ? true : false,
			
			//RITM0574613
			yearsList: Array.from(new Array(5), (val, index) => (index + (this.year - 2)).toString())
		};

	}

	async componentDidMount() {
		this.setState({ loading: true });
		//let userDivision = await this.repository.getAuditors(); //B1_Audit_Module_Optimization
		let filter = await this.getFilters();
		// Rimosse chiamate Count e implementati i count nella chiamata principale (getItems)
		// const totAudits = await this.getAuditCount(filter?.params?.year ? filter?.params?.year : this.year);
		// const itemsInMonths = await this.getAuditCountByMonth(filter?.params?.year ? filter?.params?.year : this.year);
		let itemsObj = await this.getItems(filter?.params?.year ? filter?.params?.year : this.year);
		let yearsArray = await this.repository.getAuditYearAsync();
		// if (yearsArray.length > this.years.length) this.years = yearsArray;
		//if (this.state.filteredCode != null) items = this.buildFilter(items);

		//RITM0574613
		const years = Array.from(new Array(6), (val, index) => (index + (yearsArray[0])).toString())
		
		this.setState({
			totalAudits: itemsObj.totCount,
			itemsInMonths: itemsObj.monthsCount,
			items: itemsObj.audits,
			loading: false,
			//userDivision, //B1_Audit_Module_Optimization
			filter,
			yearsList: years
		});
	}

	onDivisionTabSelected(item, index) {
		this.setState({ filteredDivision: item, filteredTab: index, currentPage: 1, loading: true, isBack: false }, async () => {
			this.refreshData();
		});
	}

	async onYearChange(selectedItem) {
		let year;
		try {
			year = selectedItem.selectedItem;
		} catch (error) {
			year = this.year;
		}
		this.setState({ filteredYear: year, filteredMonth: null, currentPage: 1, loading: true, isBack: false }, () => {
			this.refreshData();
		});
	}

	getHashtagYear = () => {
		if (this.props.location?.hash != null && this.props.location.hash.length > 1) {
			var code = decodeURIComponent(this.props.location.hash.substring(1));
			var year = code.substring(code.length - 4);
			if (year) return year;
			return this.year;
		}
		return null;
	};

	getHashtag = () => {
		if (this.props.location?.hash != null && this.props.location.hash.length > 1) {
			return decodeURIComponent(this.props.location.hash.substring(1));
		}
		return null;
	};

	// getAuditCount = async (year) => {
	// 	let totalAudits = 0;
	// 	try {
	// 		totalAudits = await this.repository.getAuditCount(year, await this.getFilters());
	// 	} catch (error) {
	// 		showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "loading audits", apioperation.GET));
	// 	}
	// 	return totalAudits;
	// };

	// getAuditCountByMonth = async (year) => {
	// 	let items = [];
	// 	try {
	// 		items = await this.repository.getAuditCountByMonth(year, await this.getFilters());
	// 	} catch (error) {
	// 		showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "loading audits", apioperation.GET));
	// 	}
	// 	return items;
	// };

	getItems = async (year, renewFilter = true) => {
		try {
			const skip = (this.state.currentPage - 1) * this.state.pageSize;
			const audits = await this.repository.getAudits(year, skip, this.state.pageSize, await this.getFilters(renewFilter));
			if (!this.state.isBack) {
				await this.repository.updateCachedAuditFilter(await this.getFilters(renewFilter));
			}
			return audits;
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "loading audits", apioperation.GET));
			return [];
		}
	};

	getItemsFromCache = async (year) => {
		let items = [];

		try {
			items = await this.repository.getCachedAudits(year);
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "loading audits", "ERROR"));
		}
		return items;
	};

	handleSearchClear = async () => {
		await this.setState(() => ({
			showFilters: false,
			filteredAuditScopes: [],
			filteredAuditReasons: [],
			filteredAuditCountries: [],
			filteredAuditProjectsAuditee: [],
			//filteredAuditSubContractors: [],
			filteredAuditSubContractors: null, //RITM0964998 - Download Audit Programs Fix
			filteredAuditType: null,
			filteredMonth: null,
			filteredTarget: null,
			filteredStatus: null,
			filteredPlanStatus: null,
			filteredAuditRemote: null,
			filteredWorkSites: [],
			filteredPlanCompiler: null,
			//filteredPurchaseOrder: [], //RITM0646764
			filteredPurchaseOrder: null, //RITM0964998 - Download Audit Programs Fix
			filteredApprover: null,
			filteredManager: null,
			filteredCompiler: null,
			filteredPlanCompiler: null,
			filteredTab: null,
			filteredDivision: null,
			//RITM0544059
			filteredSection: null,
			filteredAuditor: null,
			filteredDivisionAuditor: null,
			filteredCompanyAuditor: null,
			filteredProjectAuditor: null,

			// filteredYear : null,
			filteredCode: this.getHashtag(),
			filteredFindingCode: this.getHashtag(),
			filteredProjectAuditCode: this.getHashtag(),
			filteredProjectFindingCode: this.getHashtag(),
			isBack: false,
		}));
		this.refreshData();
	};

	onShowFilters = () => {
		this.setState((oldState) => ({ showFilters: !oldState.showFilters }));
	};

	handleChangePaging = async (page) => {
		//RITM0549692
		const lastFilter = { ...this.state.lastFilter, params: { ...this.state.lastFilter.params, page: page.page, pageSize: page.pageSize } };

		await new Promise((resolve) => {
			this.setState({ currentPage: page.page, pageSize: page.pageSize, lastFilter: lastFilter, loading: true }, resolve);
		});

		await this.repository.updateCachedAuditFilter(lastFilter);
		const itemsObj = await this.getItems(this.state.filteredYear || this.year, false);
		this.setState(() => ({
			items: itemsObj.audits,
			loading: false,
		}));
	};

	onDelete = async () => {
		this.refreshData();
	};

	getFilters = async (renew = true) => {
		if (renew) {
			let data = null;
			if (!this.state.isBack || this.state.filteredCode) {
				const filter = {
					tab: this.state.filteredTab || null,
					year: this.state.filteredYear || null,
					idDivision: this.state.filteredDivision || null,
					type: this.state.filteredAuditType || null,
					scopes: this.state.filteredAuditScopes.length > 0 ? this.state.filteredAuditScopes.map((f) => f.id).join("|") : null,
					reasons: this.state.filteredAuditReasons.length > 0 ? this.state.filteredAuditReasons.map((f) => f.id).join("|") : null,
					countriesAuditee: this.state.filteredAuditCountries.length > 0 ? this.state.filteredAuditCountries.map((f) => f.id).join("|") : null,
					projectsAuditee: this.state.filteredAuditProjectsAuditee.length > 0 ? this.state.filteredAuditProjectsAuditee.map((f) => f.id).join("|") : null,
					subContractors: this.state.filteredAuditSubContractors || null,
					idTarget: this.state.filteredTarget?.id || null,
					month: this.state.filteredMonth || null,
					idStatus: this.state.filteredStatus?.id || null,
					idPlanStatus: this.state.filteredPlanStatus?.id || null,
					auditRemote: this.state.filteredAuditRemote?.value || null,
					workSites: this.state.filteredWorkSites.length > 0 ? this.state.filteredWorkSites?.map((f) => f.id).join("|") : [],
					compiler: this.state.filteredCompiler || null,
					planCompiler: this.state.filteredPlanCompiler || null,
					purchaseOrders: this.state.filteredPurchaseOrder || null, //RITM0646764
					approver: this.state.filteredApprover || null,
					divisionManager: this.state.filteredManager || null,
					auditCode: this.state.filteredCode || null,
					findingCode: this.state.filteredFindingCode || null,
					projectAuditCode: this.state.filteredProjectAuditCode || null,
					projectFindingCode: this.state.filteredProjectFindingCode || null,
					//RITM0549692
					pageSize: this.state.pageSize,
					page: this.state.currentPage,
					//RITM0544059
					idSection: this.state.filteredSection?.id,
					idLeadAuditor: this.state.filteredAuditor?.id,
					idDivisionLeadAuditor: this.state.filteredDivisionAuditor?.id,
					idCompanyLeadAuditor: this.state.filteredCompanyAuditor?.id,
					idProjectLeadAuditor: this.state.filteredProjectAuditor?.id,
				};
				data = {
					params: {
						...filter,
					},
				};
				this.setState(() => ({
					lastFilter: data,
				}));
			} else {
				let filter = await this.repository.getCachedAuditsFilter();
				data = {
					params: Object.assign({},filter?.params ?? {}), //RITM0709290
				};
				data.params.page = 1; //RITM0549692
				//RITM0709290 - rimosso reset anno
				let status = await this.repository.getCachedStatuses();
				let targert = await this.repository.getCachedTargets();
				let worksites = await this.repository.getCachedWorkSites();
				//let scopes = await this.repository.getScopes(); //B1_Audit_Module_Optimization
				let scopes = await this.repository.getCachedScopes();
				//let reasons = await this.repository.getReasonForSampling(); //B1_Audit_Module_Optimization
				let reasons = await this.repository.getCachedReasonForSampling();
				//let countriesAuditee = await this.repository.getCountries(); //B1_Audit_Module_Optimization
				let countriesAuditee = await this.repository.getCachedCountries();
				//let projectsAuditee = await MeRepository.getProjects(null); //B1_Audit_Module_Optimization
				let projectsAuditee = await this.repository.getCachedProjects();
				//RITM0544059
				//let section = await this.repository.getSections(); //B1_Audit_Module_Optimization
				let section = await this.repository.getCachedSection();
				//let division = await MeRepository.getDivisions(); //B1_Audit_Module_Optimization
				let division = await this.repository.getCachedDivisions();
				//let companies = await MeRepository.getCompanies(); //B1_Audit_Module_Optimization
				let companies = await this.repository.getCachedCompanies();
				//let project = await MeRepository.getProjects(null); //B1_Audit_Module_Optimization
				//let userDivision = await this.repository.getAuditors(); //B1_Audit_Module_Optimization
				let userDivision = await this.repository.getCachedAuditor();


				this.setState({
					isOpenSearchForm: true,
					lastFilter: data,
					filteredMonth: filter?.params?.month || null,
					filteredTab: filter?.params?.tab || null,
					filteredStatus: status?.find((el) => el.id === filter?.params?.idStatus) || null,
					filteredPlanStatus: status?.find((el) => el.id === filter?.params?.idPlanStatus) || null,
					filteredAuditRemote: status?.find((el) => el.id === filter?.params?.name) || null,
					filteredTarget: targert?.find((el) => el.id === filter?.params?.idTarget) || null,
					filteredDivision: filter?.params?.idDivision || null,
					filteredAuditType: filter?.params?.type || null,
					filteredCompiler: filter?.params?.compiler || null,
					filteredPlanCompiler: filter?.params?.planCompiler || null,
					filteredPurchaseOrder: filter?.params?.purchaseOrders || null, //RITM0646764
					filteredApprover: filter?.params?.approver || null,
					filteredManager: filter?.params?.divisionManager || null,
					filteredCode: filter?.params?.auditCode || null,
					filteredFindingCode: filter?.params?.findingCode || null,
					filteredProjectAuditCode: filter?.params?.projectAuditCode || null,
					filteredProjectFindingCode: filter?.params?.projectFindingCode || null,
					filteredYear: filter.params?.year || null,
					//multiple
					filteredAuditScopes: filter?.params?.scopes != null ? scopes?.filter((s) => filter?.params?.scopes.includes(s.id)) || [] : [], //B1_Audit_Module_Optimization
					filteredAuditReasons: filter?.params?.reasons != null ? reasons?.filter((s) => filter?.params?.reasons.includes(s.id)) || [] : [], //B1_Audit_Module_Optimization
					filteredAuditCountries: filter?.params?.countriesAuditee != null ? countriesAuditee?.filter((s) => filter?.params?.countriesAuditee.includes(s.id)) || [] : [], //B1_Audit_Module_Optimization
					filteredAuditProjectsAuditee: filter?.params?.projectsAuditee != null ? projectsAuditee?.filter((s) => filter?.params?.projectsAuditee.includes(s.id)) || [] : [], //B1_Audit_Module_Optimization
					filteredAuditSubContractors: filter?.params?.subContractors || null ,
					filteredWorkSites: worksites?.filter((w) => filter?.params?.workSites.includes(w.id)) || [],
					//RITM0549692
					pageSize: filter?.params?.pageSize ?? 10,
					currentPage: 1,
					//RITM0544059
					filteredSection: filter.params?.idSection !=null ? section?.find((el) => el.id === filter.params?.idSection) || null : null, //B1_Audit_Module_Optimization
					filteredAuditor:  filter.params?.idLeadAuditor != null ? userDivision?.find((el) => el.id === filter.params?.idLeadAuditor) || null : null, //B1_Audit_Module_Optimization
					filteredDivisionAuditor: filter.params?.idDivisionLeadAuditor != null ? division?.find((el) => el.id === filter.params?.idDivisionLeadAuditor) || null : null, //B1_Audit_Module_Optimization
					filteredCompanyAuditor: filter.params?.idCompanyLeadAuditor != null ? companies?.find((el) => el.id === filter.params?.idCompanyLeadAuditor) || null : null, //B1_Audit_Module_Optimization
					filteredProjectAuditor: filter.params?.idProjectLeadAuditor != null ? projectsAuditee?.find((el) => el.id === filter.params?.idProjectLeadAuditor) || null : null,
				});
			}
			if (
				this.state.filteredStatus == undefined &&
				this.state.filteredPlanStatus == undefined &&
				this.state.filteredAuditRemote == undefined &&
				this.state.filteredTarget == undefined &&
				this.state.filteredAuditType == undefined &&
				this.state.filteredCompiler == undefined &&
				this.state.filteredPlanCompiler == undefined &&
				this.state.filteredPurchaseOrder == undefined && //RITM0646764
				this.state.filteredApprover == undefined &&
				this.state.filteredManager == undefined &&
				this.state.filteredCode == undefined &&
				this.state.filteredFindingCode == undefined &&
				this.state.filteredProjectAuditCode == undefined &&
				this.state.filteredProjectFindingCode == undefined &&
				//RITM0544059
				this.state.filteredSection == undefined &&
				this.state.filteredAuditor == undefined &&
				this.state.filteredDivisionAuditor == undefined &&
				this.state.filteredCompanyAuditor == undefined &&
				this.state.filteredProjectAuditor == undefined &&
				//
				(this.state.filteredAuditScopes == undefined || this.state.filteredAuditScopes.length == 0) &&
				(this.state.filteredAuditReasons == undefined || this.state.filteredAuditReasons.length == 0) &&
				(this.state.filteredAuditCountries == undefined || this.state.filteredAuditCountries.length == 0) &&
				(this.state.filteredAuditProjectsAuditee == undefined || this.state.filteredAuditProjectsAuditee.length == 0) &&
				this.state.filteredAuditSubContractors == undefined &&
				(this.state.filteredWorkSites == undefined || this.state.filteredWorkSites.length == 0)
			) {
				this.setState({ showFilters: false });
			} else {
				this.setState({ showFilters: true });
			}
			return data;
		}
		return { ...this.state.lastFilter, currentPage: 1 /*RITM0549692*/ };
	};

	onMonthFilter = (month) => {
		this.setState({ filteredMonth: month > 0 ? month : null, currentPage: 1, loading: true, isBack: false }, () => {
			this.refreshData();
		});
	};

	onAuditTypeFilter = (type) => {
		this.setState({ filteredAuditType: type, isBack: false });
	};

	onTargetFilter = (target) => {
		this.setState({ filteredTarget: target, isBack: false });
	};

	onStatusFilter = (status) => {
		this.setState({ filteredStatus: status, isBack: false });
	};

	onPlanStatusFilter = (status) => {
		this.setState({ filteredPlanStatus: status, isBack: false });
	};

	onAuditRemoteFilter = (remote) => {
		this.setState({ filteredAuditRemote: remote, isBack: false });
	};

	onAuditScopeFilter = (scopes) => {
		this.setState({ filteredAuditScopes: scopes, isBack: false });
	};

	onAuditReasonFilter = (reasons) => {
		this.setState({ filteredAuditReasons: reasons, isBack: false });
	};

	onAuditCountryFilter = (countries) => {
		this.setState({ filteredAuditCountries: countries, isBack: false });
	};

	onAuditProjectAuditeeFilter = (projectsAuditee) => {
		this.setState({ filteredAuditProjectsAuditee: projectsAuditee, isBack: false });
	};

	onAuditSubContractorFilter = (subContractors) => {
		this.setState({ filteredAuditSubContractors: subContractors, isBack: false });
	};

	onWorkSiteFilter = (worksites) => {
		this.setState({ filteredWorkSites: worksites, isBack: false });
	};

	onCompilerFilter = (compiler) => {
		this.setState({ filteredCompiler: compiler, isBack: false });
	};

	onPlanCompilerFilter = (compiler) => {
		this.setState({ filteredPlanCompiler: compiler, isBack: false });
	};

	onPurchaseOrderFilter = (purchaseOrder) => {
		this.setState({ filteredPurchaseOrder: purchaseOrder, isBack: false });
	};

	onApproverFilter = (approver) => {
		this.setState({ filteredApprover: approver, isBack: false });
	};

	onDivisionManagerFilter = (manager) => {
		this.setState({ filteredManager: manager, isBack: false });
	};

	onCodeFilter = (code) => {
		this.setState({ filteredCode: code, isBack: false });
	};

	onFindingCodeFilter = (findingCode) => {
		this.setState({ filteredFindingCode: findingCode, isBack: false });
	};

	onProjectAuditCodeFilter = (projectAuditCode) => {
		this.setState({ filteredProjectAuditCode: projectAuditCode, isBack: false });
	};

	onProjectFindingCodeFilter = (projectFindingCode) => {
		this.setState({ filteredProjectFindingCode: projectFindingCode, isBack: false });
	};

	//RITM0544059
	onChangeSectionFilter = (section) => {
		this.setState({ filteredSection: section, isBack: false });
	};
	onChangeLeadAuditorFilter = (auditor) => {
		this.setState({ filteredAuditor: auditor, isBack: false });
	};
	onChangeDivisionLeadAuditorFilter = (divisionAuditor) => {
		this.setState({ filteredDivisionAuditor: divisionAuditor, isBack: false });
	};
	onChangeCompanyLeadAuditorFilter = (companyAuditor) => {
		this.setState({ filteredCompanyAuditor: companyAuditor, isBack: false });
	};
	onChangeProjectLeadAuditorFilter = (projectAuditor) => {
		this.setState({ filteredProjectAuditor: projectAuditor, isBack: false });
	};

	showAddAudit() {
		this.setState((oldState) => ({
			modalAuditVisible: !oldState.modalAuditVisible,
			auditToModify: null,
		}));
	}

	showEditAudit(row) {
		this.setState((oldState) => ({
			modalAuditVisible: !oldState.modalAuditVisible,
			auditToModify: oldState.items.find((item) => item.id === row.id),
		}));
	}

	newAuditAdded = async (item) => {
		this.repository.updateCachedAuditList(item, item.referenceYear);
		await new Promise((resolve) => {
			this.setState(
				{
					currentPage: 1,
					filteredMonth: null,
					filteredYear: item.referenceYear,
					loading: true,
					modalAuditVisible: false,
				},
				resolve
			);
		});
		this.handleSearchClear();
	};

	async refreshData() {
		this.setState({ loading: true });
		// Rimosse chiamate e implementati i count nella chiamata principale (getItems)
		//const totAudits = await this.getAuditCount(this.state.filteredYear ? this.state.filteredYear : this.year);
		//const itemsInMonths = await this.getAuditCountByMonth(this.state.filteredYear ? this.state.filteredYear : this.year);
		const itemsObj = await this.getItems(this.state.filteredYear ? this.state.filteredYear : this.year);
		// if (this.state.filteredCode != null) items = this.buildFilter(items);
		this.setState({
			totalAudits: itemsObj.totCount,
			itemsInMonths: itemsObj.monthsCount,
			items: itemsObj.audits,
			loading: false,
		});
	}

	auditUpdated = async (auditPlan) => {
		await new Promise((resolve) => {
			this.setState(
				{
					currentPage: 1,
					filteredMonth: null,
					filteredYear: auditPlan.referenceYear,
					loading: true,
					modalAuditVisible: false,
				},
				resolve
			);
		});
		await this.repository.updateCachedAuditList(auditPlan, auditPlan.referenceYear);
		this.handleSearchClear();
	};

	render() {
		const paginationProps = () => ({
			page: this.state.currentPage || 1,
			totalItems: this.state.totalAudits || 0,
			pageSize: this.state.pageSize || 10,
			pageSizes: [5, 10, 20, 30, 40, 50],
			onChange: this.handleChangePaging,
		});
		return (
			<AppContext.Consumer>
				{({ user }) =>
					IsEnabled(user, "Audit") ? (
						<>
							<PageBreadCrumb linkTo="/modules" linkText="Modules" titleLeft="Audit" />
							<div className="mainContainer">
								<div className="bx--grid content full-width mainContainer ">
									<div className="bx--row">
										<DivisionsTab
											key={this.state.filteredTab}
											selectedTab={this.state.filteredTab}
											onSelectedTab={this.onDivisionTabSelected}
											onError={(error) => {
												// showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "loading division", apioperation.GET)); //RITM0945977
												showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "loading business line", apioperation.GET));
											}}
										/>
									</div>
									<div className="bx--row">
										<h4 className="description-page">
											Current year
											<Dropdown
												id="ddYear"
												items={this.state.yearsList}
												onChange={this.onYearChange}
												initialSelectedItem={this.year.toString()}
												selectedItem={this.state.filteredYear ? this.state.filteredYear.toString() : this.year.toString()}
												itemToString={(item) => item || ""}
												type="inline"
												label=""
											/>
										</h4>
									</div>

									{this.state.modalAuditVisible ? (
										<AuditDetails
											Audit={this.state.auditToModify}
											onCancel={this.showAddAudit}
											onSave={this.newAuditAdded}
											onUpdate={this.auditUpdated}
											user={user}
											//userDivision={this.state.userDivision} //B1_Audit_Module_Optimization
										/>
									) : null}
									{this.state.loading ? (
										<DataTableSkeleton />
									) : (
										<div>
											<AuditMultiSelectDataTable
												key={this.state.lastFilter + this.year.toString() + this.state.filteredYear || 'filter'}
												audits={this.state.items}
												itemsInMonths={this.state.itemsInMonths}
												totalItems={this.state.totalAudits?.toString()}
												// allYearAudits={this.state.allYearFilteredItems}
												showFilters={this.state.showFilters}
												onShowFilters={this.onShowFilters}
												onNewAudit={this.showAddAudit}
												onEditAudit={this.showEditAudit}
												onStatusChange={this.onStatusChange}
												onRefreshData={() => this.refreshData()}
												onDelete={this.onDelete}
												onMonthFilter={this.onMonthFilter}
												onTypeFilter={this.onAuditTypeFilter}
												onScopeFilter={this.onAuditScopeFilter}
												onReasonFilter={this.onAuditReasonFilter}
												onCountryFilter={this.onAuditCountryFilter}
												onProjectAuditeeFilter={this.onAuditProjectAuditeeFilter}
												onSubContractorFilter={this.onAuditSubContractorFilter}
												onTargetFilter={this.onTargetFilter}
												onStatusFilter={this.onStatusFilter}
												onPlanStatusFilter={this.onPlanStatusFilter}
												onAuditRemoteFilter={this.onAuditRemoteFilter}
												onWorkSiteFilter={this.onWorkSiteFilter}
												onSearchClear={this.handleSearchClear}
												onSearch={() => this.refreshData()}
												//RITM0544059
												onChangeSectionFilter={this.onChangeSectionFilter}
												onChangeLeadAuditorFilter={this.onChangeLeadAuditorFilter}
												onChangeDivisionLeadAuditorFilter={this.onChangeDivisionLeadAuditorFilter}
												onChangeCompanyLeadAuditorFilter={this.onChangeCompanyLeadAuditorFilter}
												onChangeProjectLeadAuditorFilter={this.onChangeProjectLeadAuditorFilter}
												//
												selectedAuditType={this.state.filteredAuditType}
												selectedScopes={this.state.filteredAuditScopes}
												selectedReasons={this.state.filteredAuditReasons}
												selectedCountries={this.state.filteredAuditCountries}
												selectedProjectsAuditee={this.state.filteredAuditProjectsAuditee}
												selectedSubContractors={this.state.filteredAuditSubContractors}
												selectedTarget={this.state.filteredTarget}
												selectedYear={this.state.filteredYear}
												selectedStatus={this.state.filteredStatus}
												selectedPlanStatus={this.state.filteredPlanStatus}
												selectedAuditRemote={this.state.filteredAuditRemote}
												selectedWorkSites={this.state.filteredWorkSites}
												selectedCompiler={this.state.filteredCompiler}
												selectedPlanCompiler={this.state.filteredPlanCompiler}
												selectedPurchaseOrder={this.state.filteredPurchaseOrder}
												selectedApprover={this.state.filteredApprover}
												selectedDivisionManager={this.state.filteredManager}
												selectedMonth={this.state.filteredMonth}
												selectedCode={this.state.filteredCode}
												selectedFindingCode={this.state.filteredFindingCode}
												selectedProjectAuditCode={this.state.filteredProjectAuditCode}
												selectedProjectFindingCode={this.state.filteredProjectFindingCode}
												//RITM0544059
												selectedSection={this.state.filteredSection}
												//userDivision={this.state.userDivision} //B1_Audit_Module_Optimization
												selectedLeadAuditor={this.state.filteredAuditor}
												selectedDivisionLeadAuditor={this.state.filteredDivisionAuditor}
												selectedCompanyLeadAuditor={this.state.filteredCompanyAuditor}
												selectedProjectLeadAuditor={this.state.filteredProjectAuditor}
												//
												onCompilerFilter={this.onCompilerFilter}
												onPlanCompilerFilter={this.onPlanCompilerFilter}
												onPurchaseOrderFilter={this.onPurchaseOrderFilter}
												onApproverFilter={this.onApproverFilter}
												onDivisionManagerFilter={this.onDivisionManagerFilter}
												onCodeFilter={this.onCodeFilter}
												onFindingCodeFilter={this.onFindingCodeFilter}
												onProjectAuditCodeFilter={this.onProjectAuditCodeFilter}
												onProjectFindingCodeFilter={this.onProjectFindingCodeFilter}
												filters={this.state.lastFilter?.params || []}
											/>
											<div className="footer-pagination">
												<Pagination {...paginationProps()} />
											</div>
										</div>
									)}
								</div>
							</div>
						</>
					) : null
				}
			</AppContext.Consumer>
		);
	}
}
